import axios from 'axios';
import { ActionTree } from 'vuex';
import { ArchiveState } from '../stores/archive.store';
import { RootState } from '../store';
import {
  mutationError,
  mutationLoadingTeams,
  mutationSetTeams,
  mutationSetScopeFilter,
  mutationSetEndDateFilter,
  mutationApplyEndDateFilter,
  mutationSetTagFilter,
  mutationSetTags,
  mutationLoadingTags,
  mutationSetGroupFilter,
} from '../mutations/archive.mutations';
import { ITag } from '@/types/Tag';
import GroupFiltersEnum from '@/enums/GroupFilters';

export const actionLoadTeams = 'loadTeams';
export const actionSetScopeFilter = 'setScopeFilter';
export const actionSetEndDateFilter = 'setEndDateFilter';
export const actionApplyEndDateFilter = 'applyEndDateFilter';
export const actionLoadTags = 'loadTags';
export const actionSetTagFilter = 'setTagFilter';
export const actionSetGroupFilter = 'setGroupFilter';

export const actions: ActionTree<ArchiveState, RootState> = {
  async [actionLoadTeams]({ commit }) {
    try {
      commit(mutationLoadingTeams, true);
      const { data } = await axios.get('/get/settings/scope');
      const teams = data.map(team => ({
        ...team[0],
        id: team[0].id || team[0].name,
      }));
      commit(mutationSetTeams, teams);
    } catch (err) {
      commit(mutationError, err);
    }
  },
  async [actionSetScopeFilter]({ commit }, payload) {
    commit(mutationSetScopeFilter, payload);
  },
  async [actionSetEndDateFilter]({ commit }, payload) {
    commit(mutationSetEndDateFilter, payload);
  },
  async [actionApplyEndDateFilter]({ commit }) {
    commit(mutationApplyEndDateFilter);
  },
  async [actionLoadTags]({ commit }) {
    commit(mutationLoadingTags, true);
    const {
      data: { tags = [] },
    } = await axios.get('/get/settings/entity_tags');
    const payload: ITag[] = tags.map((tag: any) => ({
      id: tag.tag_id,
      title: tag.title,
      status: tag.status,
    }));
    commit(mutationSetTags, payload);
    commit(mutationLoadingTags, false);
  },
  async [actionSetTagFilter]({ commit }, tags: string[]) {
    commit(mutationSetTagFilter, tags);
  },
  async [actionSetGroupFilter]({ commit }, payload: GroupFiltersEnum) {
    commit(mutationSetGroupFilter, payload);
  },
};
